import React, { FC, useCallback, useEffect, useState } from 'react';
import key from '../../../../assets/img/key.png';
import {
  Button,
  Checkbox,
  DatePicker,
  Divider,
  Dropdown,
  Input,
  List,
  Modal,
  Progress,
  Row,
  Space,
  Spin,
  Tag,
  Tooltip,
  Image,
  Typography,
} from 'antd';
import Title from 'antd/lib/typography/Title';
import {
  CalendarOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  SnippetsOutlined,
  CloseCircleOutlined,
  SwapRightOutlined,
  UserOutlined,
  TeamOutlined,
  ClockCircleOutlined,
  PlusOutlined,
  CheckOutlined,
} from '@ant-design/icons';
import KeyResultCard from '../../../../components/molecules/keyResultCard/KeyResultCard';
import { useConnection, useEvents, useUserInfo } from '../../../../connection/Application';
import Form from '../../../../form/Form';
import dayjs from 'dayjs';
import SelectStatus from '../../../../form/adapters/selectStatus';
import KeyResult from './KeyResult';
import { useParams } from 'react-router-dom';
import UpdatesCard from '../../../../components/molecules/updatesCard/UpdatesCard';
import './goal.less';
import MarksPopOver from '../../../../components/molecules/MarksPopOver/MarksPopOver';
const { confirm } = Modal;
const { RangePicker } = DatePicker;
const { TextArea } = Input;

const { Text } = Typography;

const getKeyResultWeight = (weight?: number | string | null) => {
  const parsedWeight = Number(weight);
  return Number.isFinite(parsedWeight) ? parsedWeight : 1;
};

const calculateObjectiveCompleted = (keyResults: any[]) => {
  if (!keyResults?.length) {
    return 0;
  }

  const { totalCompleted, totalWeight } = keyResults.reduce(
    (acc: { totalCompleted: number; totalWeight: number }, keyResult: any) => {
      const weight = getKeyResultWeight(keyResult?.weight);
      const completed = Number(keyResult?.completed ?? 0);
      return {
        totalCompleted: acc.totalCompleted + (Number.isFinite(completed) ? completed : 0) * weight,
        totalWeight: acc.totalWeight + weight,
      };
    },
    { totalCompleted: 0, totalWeight: 0 },
  );

  if (totalWeight === 0) {
    return 0;
  }

  return Math.round((totalCompleted / totalWeight) * 100) / 100;
};

export type Props = {
  disable?: boolean;
  goalSummaryId?: number;
  id?: number;
  performanceCycle: {
    endDate: string;
    id: number;
    name: string;
    startDate: string;
    status: string;
    teamSelfEvaluation?: boolean;
  };
  new?: boolean;
  duration?: [string, string];
  setError?: (error: string, isError: boolean) => void;
  setClose?: () => void;
  mode: 'view' | 'edit';
  teamId?: number;
  goalSummaryOwner?: number;
  isLeader?: boolean;
};

const Objective: FC<Props> = (props) => {
  const connection = useConnection();
  const { id, goalSummaryOwner, isLeader } = props;
  const user = useUserInfo();
  const [viewDetails, setViewDetails] = useState<any>();
  const [viewDetails1, setViewDetails1] = useState<any>();
  const [mode, setMode] = useState<'view' | 'edit'>('view');
  const [form] = Form.useForm();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [teamGoals, setTeamGoals] = useState<any>([]);
  const newKeyNumber = React.useRef<number>(0);
  const keyResultId = React.useRef<string | undefined>('');
  const [keyResultOpen, setKeyResultOpen] = useState<boolean>(false);
  const params = useParams<{ type: string; id: string; name: string; cycle: string }>();
  const [keyObject, setKeyObject] = useState<any>();
  const [loading, setLoading] = useState(false);
  const [loading1, setLoading1] = useState(false);
  const [loading2, setLoading2] = useState(false);
  // const [supervisors, setSupervisors] = useState<number[]>([]);
  const [isSupervisor, setIsSupervisor] = useState<boolean>(false);
  const [goalMarkValues, setGoalMarkValues] = useState<{
    userMark?: number;
    userComment?: string;
    supervisorMark?: string | number;
    supervisorComment?: string;
  }>({});
  const isTeamSelfEvaluationEnabled = props.performanceCycle?.teamSelfEvaluation ?? false;
  const events = useEvents();

  // const history1 = useHistory();

  useEffect(() => {
    window.onbeforeunload = function () {
      return 'Data will be lost if you leave the page, are you sure?';
    };
    return () => {
      window.onbeforeunload = null;
    };
  });

  useEffect(() => {
    let isMounted = true; // note mutable flag
    setLoading1(true);
    const supervisorList: number[] = [];
    if (props.teamId && props.performanceCycle?.id) {
      connection
        .get(`common/${params.type}/${params.id}/${props.teamId}/${props.performanceCycle?.id}`)
        .then((res: any) => {
          if (isMounted) {
            for (const item of res?.response?.supervisors) {
              supervisorList.push(item.id);
            }
            // setSupervisors(supervisorList);
            if (user && user?.userId !== +params.id && supervisorList.includes(user.userId)) {
              setIsSupervisor(true);
            } else {
              setIsSupervisor(false);
            }
          }
        })
        .finally(() => setLoading1(false));
    }
    return () => {
      isMounted = false;
    };
  }, [connection, params, props?.performanceCycle?.id, props?.teamId, user]);

  const getGoalMarks = useCallback(() => {
    if (id) {
      // setLoading2(true);
      connection
        .get(`goals/${params.type}/goal-mark/${id}/values`)
        .then((res) => {
          setGoalMarkValues(res.response?.body);
        })
        .catch((e) => console.log(e))
        .finally(() => setLoading2(false));
    }
  }, [connection, id, params.type]);

  const recalculateObjective = useCallback((details: any) => {
    const keyResults = details?.keyResults ?? [];
    const newCompleted = calculateObjectiveCompleted(keyResults);
    let newStatus: string;
    let test1 = keyResults.findIndex((item: any) => item.status === 'On-hold');
    if (test1 === -1) {
      test1 = keyResults.findIndex((item: any) => item.status === 'Offtrack');
      if (test1 === -1) {
        test1 = keyResults.findIndex((item: any) => item.status === 'Ontrack');
        if (test1 === -1) {
          test1 = keyResults.findIndex((item: any) => item.status === 'Not Started');
          if (test1 === -1) {
            test1 = keyResults.findIndex((item: any) => item.status === 'Completed');
            if (test1 === -1) {
              newStatus = 'Pending';
            } else {
              newStatus = 'Completed';
            }
          } else {
            newStatus = 'Not Started';
          }
        } else {
          newStatus = 'Ontrack';
        }
      } else {
        newStatus = 'Offtrack';
      }
    } else {
      newStatus = 'On-hold';
    }
    return {
      ...details,
      completed: newCompleted,
      status: newStatus,
    };
  }, []);

  const setDetails = useCallback(() => {
    setViewDetails((prev: any) => {
      if (!prev) return prev;
      const updated = recalculateObjective(prev);
      if (prev.completed === updated.completed && prev.status === updated.status) {
        return prev;
      }
      return updated;
    });
  }, [recalculateObjective]);

  useEffect(() => {
    let isMounted = viewDetails === undefined; // note mutable flag
    setMode(props.mode ?? 'view');
    if (props.new) {
      if (isMounted) {
        const newGoal = {
          title: '',
          description: '',
          status: 'Pending',
          keyResults: [],
          startDate: props?.duration?.[0],
          endDate: props?.duration?.[1],
          parent: 0,
        };
        setViewDetails(newGoal);
        isMounted = false;
        form.setFieldsValue(newGoal);
      }
    } else {
      if (isMounted) {
        setLoading(true);
      }
      connection.get(`goals/objective/${id}`).then((res) => {
        if (isMounted) {
          setViewDetails(res.response);
          setViewDetails1(res.response);
          form.setFieldsValue(res.response);
          setLoading(false);
          isMounted = false;
        } else if (
          viewDetails !== undefined &&
          viewDetails.keyResults.length !== res.response.keyResults.length
        ) {
          setViewDetails({ ...viewDetails, keyResults: res.response.keyResults });
          setViewDetails1({ ...viewDetails, keyResults: res.response.keyResults });
        }
        setLoading(false);
      });
    }
    getGoalMarks();
    return () => {
      isMounted = false;
    };
  }, [connection, form, getGoalMarks, id, props?.duration, props.mode, props.new, viewDetails]);

  useEffect(() => {
    let isMounted = true; // note mutable flag
    const teamGoals: any[] = [];
    if (props?.performanceCycle?.id)
      connection.get(`users/teams/${params.id}/${props?.performanceCycle?.id}`).then((res) => {
        if (isMounted) {
          res.response.forEach((object: any) => {
            object.goals?.forEach((goal: any) => {
              const id = goal.id;
              const value = goal.title;
              teamGoals.push({ id, value, teamId: goal?.teamId });
            });
          });
          setTeamGoals(teamGoals.filter((e: any) => e.teamId === props?.teamId));
        }
      });
    return () => {
      isMounted = false;
    };
  }, [connection, params?.id, props?.performanceCycle?.id, props?.teamId, user?.userId]);

  const showDeleteConfirm = useCallback(
    (id: number) => {
      confirm({
        title: `You are about to delete this Objective.`,
        icon: <ExclamationCircleOutlined style={{ color: 'red' }} />,
        content: `Are you sure?`,
        okText: 'Yes',
        centered: true,
        okType: 'danger',
        cancelText: 'Cancel',
        onOk() {
          connection
            .delete(`goals/${id}`)
            .then(() => {
              props.setClose?.();
            })
            .catch((e) => console.log(e));
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    [connection, props],
  );
  const showErrorModal = useCallback((error: string) => {
    confirm({
      title: 'Error',
      icon: <CloseCircleOutlined />,
      content: error,
      okText: 'Yes,Discard it!',
      okButtonProps: { style: { display: 'none' } },
      centered: true,
      okType: 'primary',
      cancelText: 'Cancel',
      onCancel() {
        console.log('Cancel');
      },
    });
  }, []);
  const saveDetails = useCallback(
    (x?: { reusable?: boolean; viewDetails?: any }) => {
      setLoading(true);
      const viewDetailsX = x?.viewDetails ?? viewDetails;
      if (viewDetailsX?.title === '' || viewDetailsX?.keyResults.length === 0) {
        if (viewDetailsX?.title === '' && viewDetailsX?.keyResults.length === 0) {
          props.setError?.('Objective title and key results are missing', true);
        } else if (viewDetailsX?.title === '') {
          props.setError?.('Objective title is missing', true);
        } else if (viewDetailsX?.keyResults.length === 0) {
          props.setError?.('Key Results are missing', true);
        }
        setLoading(false);
      } else {
        let newGoal = { ...viewDetailsX };
        if (x?.reusable !== undefined) {
          newGoal = { ...newGoal, reusable: x.reusable };
        }
        const performanceCycle = newGoal?.performanceCycle?.id;
        const id = newGoal?.id;
        delete newGoal?.id;
        delete newGoal?.keyResults;
        delete newGoal?.progress;
        delete newGoal?.owner;
        delete newGoal?.weight;
        delete newGoal?.teamWeight;
        delete newGoal?.goalHolder;
        delete newGoal?.ownerId;
        delete newGoal?.performanceCycle;
        newGoal.parent = newGoal?.parent?.id ?? newGoal?.parent;
        const editingGoal = {
          ...newGoal,
          owner: params?.id,
          performanceCycle,
        };
        if (id)
          connection
            .patch(`goals/${id}`, {
              goal: editingGoal,
            })
            .then(() => props.setError?.('', false))
            .catch((e) => console.error(e))
            .finally(() => {
              setViewDetails1(viewDetails);
              setLoading(false);
            });
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    },
    [connection, params?.id, props, viewDetails],
  );

  const createGoal = useCallback(async () => {
    setLoading(true);
    if (viewDetails?.title === '' || viewDetails?.keyResults.length === 0) {
      if (viewDetails?.title === '' && viewDetails?.keyResults.length === 0) {
        showErrorModal('Objective title and key results are missing');
      } else if (viewDetails?.title === '') {
        showErrorModal('Objective Title is missing');
      } else if (viewDetails?.keyResults.length === 0) {
        showErrorModal('Key results are missing');
      }
      setLoading(false);
    } else {
      const newGoal = { ...viewDetails };
      const owner = props.goalSummaryId;
      newGoal?.keyResults.forEach((item: any) => {
        delete item.id;
      });
      const keyResults = newGoal?.keyResults;
      delete newGoal?.keyResults;
      const goal = {
        ...newGoal,
        owner,
        performanceCycle: props?.performanceCycle?.id,
      };
      connection
        .post('goals', {
          goal,
          keyResults,
        })
        .then(() => props.setClose?.())
        .catch((e) => console.log(e))
        .finally(() => setLoading(false));
    }
  }, [connection, props, showErrorModal, viewDetails]);

  const addKeyResult = useCallback(() => {
    keyResultId.current = `new ${newKeyNumber.current}`;
    newKeyNumber.current += 1;
    setKeyObject(undefined);
    setKeyResultOpen(true);
  }, []);

  const menu = (
    <Button
      type="default"
      danger
      style={{ color: 'red', border: 'red 1px solid', cursor: 'pointer' }}
      onClick={() => showDeleteConfirm(viewDetails.id)}
      icon={<DeleteOutlined style={{ marginRight: 5 }} />}>
      Delete
    </Button>
  );

  return (
    <div>
      <Spin spinning={loading || loading1 || loading2}>
        {mode === 'edit' && !props.new && (
          <Space
            style={{
              marginTop: 0,
              right: 20,
              justifyContent: 'flex-end',
              display: 'flex',
              position: 'absolute',
            }}>
            <Dropdown.Button overlay={menu} trigger={['click']} />
          </Space>
        )}
        <Form form={form}>
          <div
            className="input-hover2"
            style={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              marginRight: 50,
            }}>
            {mode === 'edit' && (
              <TextArea
                allowClear
                className="input-hover"
                value={viewDetails?.title}
                placeholder={viewDetails?.title === '' ? 'Objective Title' : ''}
                bordered={false}
                autoSize={{ minRows: 1, maxRows: 7 }}
                onChange={(e) => {
                  setViewDetails({ ...viewDetails, title: e.target.value });
                  // if (!props.new && e.target.value === '')
                  //   saveDetails({ viewDetails: { ...viewDetails, title: e.target.value } });
                }}
                onBlur={() => {
                  if (
                    !props.new &&
                    viewDetails?.title !== viewDetails1?.title &&
                    viewDetails?.title !== ''
                  )
                    saveDetails();
                }}
              />
            )}
            {mode === 'view' && (
              <Typography
                style={{
                  fontSize: 25,
                  fontWeight: 'bold',
                  color: 'black',
                  padding: 0,
                  cursor: 'default',
                }}>
                {viewDetails?.title === '' ? 'Objective Title' : viewDetails?.title}
              </Typography>
            )}
          </div>
          <div
            className="input-hover2"
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              marginBottom: 20,
            }}>
            {mode === 'edit' && (
              <TextArea
                allowClear
                className="input-hover1"
                value={viewDetails?.description}
                placeholder={
                  viewDetails?.description === '' ? 'Enter the Objective description' : ''
                }
                bordered={false}
                style={{ fontSize: 17, color: 'grey', padding: 0, marginRight: 20 }}
                onChange={(e) => {
                  setViewDetails({ ...viewDetails, description: e.target.value });
                  // if (!props.new && e.target.value === '')
                  //   saveDetails({ viewDetails: { ...viewDetails, description: e.target.value } });
                }}
                onBlur={() => {
                  if (!props.new && viewDetails?.description !== viewDetails1?.description)
                    saveDetails();
                }}
                autoSize={{ minRows: 1, maxRows: 7 }}
              />
            )}
            {mode === 'view' && (
              <Typography
                style={{
                  fontSize: 17,
                  color: 'grey',
                  padding: 0,
                  marginRight: 20,
                  cursor: 'default',
                }}>
                {viewDetails?.description === '' ? '' : viewDetails?.description}
              </Typography>
            )}
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 10 }}>
            <div style={{ marginBottom: 10 }}>
              {mode === 'edit' && (
                <Checkbox
                  checked={viewDetails?.reusable ?? false}
                  onChange={(e) => {
                    setViewDetails({ ...viewDetails, reusable: e.target.checked });
                    if (!props.new) saveDetails({ reusable: e.target.checked });
                  }}>
                  Reusable
                </Checkbox>
              )}
            </div>
          </div>
          {/*<Row style={{ alignItems: 'center', margin: '10px 0' }}>*/}
          {/*  <Text type="secondary" style={{ marginRight: 10 }}>*/}
          {/*    Weight*/}
          {/*  </Text>*/}
          {/*  <InputNumber*/}
          {/*    onChange={(e) => {*/}
          {/*      if (props.goalSummaryOwner) {*/}
          {/*        setViewDetails({ ...viewDetails, weight: e });*/}
          {/*      } else {*/}
          {/*        setViewDetails({ ...viewDetails, teamWeight: e });*/}
          {/*      }*/}
          {/*    }}*/}
          {/*    onBlur={(e: any) => {*/}
          {/*      console.log(e.target.value);*/}
          {/*      connection*/}
          {/*        .post(*/}
          {/*          `goals/${props.goalSummaryOwner ? 'weight' : 'team-weight'}/${viewDetails.id}`,*/}
          {/*          { weight: +e.target.value },*/}
          {/*        )*/}
          {/*        .catch((e1) => console.error(e1));*/}
          {/*    }}*/}
          {/*    keyboard={true}*/}
          {/*    min={0}*/}
          {/*    type={'number'}*/}
          {/*    value={*/}
          {/*      props.goalSummaryOwner ? viewDetails?.weight ?? 0 : viewDetails?.teamWeight ?? 0*/}
          {/*    }*/}
          {/*    style={{ width: '30%' }}*/}
          {/*  />*/}
          {/*</Row>*/}
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {props.disable !== true && !props.new && !loading2 && (
              <>
                {viewDetails?.goalHolder == params.id &&
                  (goalSummaryOwner || isTeamSelfEvaluationEnabled) && (
                    <Space
                      align={'start'}
                      size={65}
                      style={{
                        display: 'flex',
                        alignContent: 'center',
                        flexDirection: 'row',
                        alignItems: 'baseline',
                        marginBottom: 10,
                      }}>
                      <Space>
                        <UserOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
                        <Text type="secondary">Self Evaluation</Text>
                      </Space>
                      {user?.userId !== goalSummaryOwner && !isLeader ? (
                        <Typography>
                          {goalMarkValues?.userMark ?? (
                            <Tag icon={<ClockCircleOutlined />} color="blue">
                              Pending
                            </Tag>
                          )}
                        </Typography>
                      ) : (
                        <MarksPopOver
                          setLoading={setLoading}
                          goal={viewDetails?.title ?? ''}
                          value={{
                            value: goalMarkValues?.userMark,
                            comment: goalMarkValues?.userComment,
                          }}
                          goalId={id ?? 0}
                          type="user"
                          mode={
                            goalMarkValues?.userMark && goalMarkValues?.supervisorMark
                              ? 'view'
                              : 'edit'
                          }
                          onSubmit={() => getGoalMarks()}
                          disableSet={
                            viewDetails?.status === 'Pending' ||
                            viewDetails?.keyResults?.find((n: any) => n?.status === 'Pending')
                          }
                          objectiveType={params.type}
                        />
                      )}
                    </Space>
                  )}
                <Space
                  align={'start'}
                  size={22}
                  style={{
                    display: 'flex',
                    alignContent: 'center',
                    flexDirection: 'row',
                    alignItems: 'baseline',
                    marginBottom: 10,
                  }}>
                  <Space>
                    <TeamOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
                    <Text type="secondary">Supervisor Evaluation</Text>
                  </Space>
                  {!(user?.userId !== goalSummaryOwner && isSupervisor) ? (
                    <Typography>
                      {goalMarkValues?.supervisorMark ? (
                        goalMarkValues.supervisorMark === 'waiting' ? (
                          <Tag icon={<CheckOutlined />} color="green">
                            Completed
                          </Tag>
                        ) : (
                          goalMarkValues?.supervisorMark
                        )
                      ) : (
                        <Tag icon={<ClockCircleOutlined />} color="blue">
                          Pending
                        </Tag>
                      )}
                    </Typography>
                  ) : (
                    <MarksPopOver
                      setLoading={setLoading}
                      goal={viewDetails?.title ?? ''}
                      value={{
                        value: goalMarkValues?.supervisorMark as number,
                        comment: goalMarkValues?.supervisorComment,
                      }}
                      goalId={id ?? 0}
                      type="supervisor"
                      onSubmit={() => {
                        getGoalMarks();
                      }}
                      mode={'edit'}
                      disableSet={
                        viewDetails?.status === 'Pending' ||
                        viewDetails?.keyResults?.find((n: any) => n?.status === 'Pending')
                      }
                      objectiveType={params.type}
                    />
                  )}
                </Space>
              </>
            )}

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: 10,
              }}>
              <Space
                align={'start'}
                size={props.new ? 20 : 86}
                style={{
                  display: 'flex',
                  alignContent: 'center',
                  flexDirection: 'row',
                  alignItems: 'baseline',
                }}>
                <Space>
                  <CalendarOutlined style={{ color: 'rgba(0, 0, 0, 0.45)' }} />
                  <Text type="secondary">Duration</Text>
                </Space>
                {mode === 'edit' && (
                  <RangePicker
                    bordered={false}
                    value={
                      viewDetails?.startDate
                        ? [dayjs(viewDetails?.startDate), dayjs(viewDetails?.endDate)]
                        : null
                    }
                    disabledDate={(current) => {
                      return (
                        current &&
                        (dayjs(props?.performanceCycle?.endDate) < current ||
                          current < dayjs(props?.performanceCycle?.startDate))
                      );
                    }}
                    clearIcon={false}
                    suffixIcon={null}
                    onChange={(val, dateStrings) => {
                      setViewDetails({
                        ...viewDetails,
                        startDate: dateStrings[0],
                        endDate: dateStrings[1],
                      });
                    }}
                    onBlur={() => {
                      if (
                        !props.new &&
                        (viewDetails?.startDate !== viewDetails1?.startDate ||
                          viewDetails?.endDate !== viewDetails1?.endDate)
                      )
                        saveDetails();
                    }}
                  />
                )}
                {mode === 'view' && (
                  <Typography style={{ cursor: 'default' }}>
                    {viewDetails?.startDate} <SwapRightOutlined /> {viewDetails?.endDate}
                  </Typography>
                )}
              </Space>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                marginBottom: '5px',
                width: '100%',
              }}>
              <Progress
                style={{ paddingRight: '15px' }}
                percent={+viewDetails?.completed}
                strokeColor={
                  viewDetails?.status === 'Completed'
                    ? 'green'
                    : viewDetails?.status === 'Pending'
                    ? 'blue'
                    : viewDetails?.status === 'On-hold'
                    ? 'cyan'
                    : viewDetails?.status === 'Offtrack'
                    ? 'red'
                    : viewDetails?.status === 'Ontrack'
                    ? '#f4d03f'
                    : ''
                }
              />
              <div style={{ width: 200 }}>
                {viewDetails?.status && (
                  <SelectStatus
                    disable={props.disable ?? false}
                    value={viewDetails?.status}
                    defaultValue={viewDetails?.status}
                    bordered={false}
                    onChange={(val) => {
                      setViewDetails({ ...viewDetails, status: val });
                    }}
                    onBlur={() => {
                      if (!props.new && viewDetails?.status !== viewDetails1?.status) saveDetails();
                    }}
                  />
                )}
              </div>
            </div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            <Row style={{ alignItems: 'center' }}>
              <Space>
                <Image preview={false} width={20} src={key} />
                <Title level={5} style={{ marginBottom: 0, paddingBottom: 6 }}>
                  Key Results
                </Title>
                {/*<KeyOutlined style={{ fontSize: 20 }} />*/}
                <Text style={{ marginBottom: 0, paddingBottom: 6 }}>
                  (At least one key result must be added)
                </Text>
              </Space>
            </Row>
            <Divider orientation="left" style={{ marginTop: 10, marginBottom: 10 }} />
            {mode === 'edit' && (
              <Button type="primary" onClick={addKeyResult}>
                <PlusOutlined style={{ fontSize: '100%', color: 'white' }} /> Add Key Result
              </Button>
            )}
            {viewDetails?.keyResults?.length !== 0 && (
              <List
                style={{ marginTop: '3%', marginBottom: '3%' }}
                dataSource={viewDetails?.keyResults?.sort(
                  (a: any, b: any) => parseFloat(a.id) - parseFloat(b.id),
                )}
                renderItem={(item: any) => (
                  <Tooltip title="Click to Edit">
                    <KeyResultCard
                      item={item}
                      onClick={() => {
                        keyResultId.current = item.id;
                        setKeyObject(item);
                        setKeyResultOpen(true);
                      }}
                    />
                  </Tooltip>
                )}
              />
            )}
            {viewDetails?.keyResults?.length === 0 && <div style={{ height: 30 }} />}
            {/*<Row style={{ alignItems: 'center' }}>*/}
            {/*  <Space>*/}
            {/*    <Title level={5}>Parent Objective</Title>*/}
            {/*    <ClusterOutlined style={{ fontSize: 20 }} />*/}
            {/*  </Space>*/}
            {/*</Row>*/}
            {/*<Divider orientation="left" style={{ marginTop: 0, marginBottom: 0 }} />*/}

            {/*<Row style={{ alignItems: 'center', marginTop: '2%' }}>*/}
            {/*  <Space>*/}
            {/*    /!* <Typography>{}</Typography> *!/*/}
            {/*    {mode === 'edit' && (*/}
            {/*      <SelectSearch*/}
            {/*        values={teamGoals}*/}
            {/*        value={viewDetails?.parent?.id}*/}
            {/*        onChange={(val) => {*/}
            {/*          let x;*/}
            {/*          if (viewDetails?.parent?.id) {*/}
            {/*            x = { ...viewDetails };*/}
            {/*            x.parent.id = val;*/}
            {/*          } else {*/}
            {/*            x = { ...viewDetails, parent: val };*/}
            {/*          }*/}
            {/*          setViewDetails(x);*/}
            {/*        }}*/}
            {/*        style={{ width: 200 }}*/}
            {/*        placeholder={!viewDetails?.parent ? 'Select parent objective' : ''}*/}
            {/*        bordered={false}*/}
            {/*        onBlur={() => {*/}
            {/*          if (!props.new) saveDetails();*/}
            {/*        }}*/}
            {/*      />*/}
            {/*    )}*/}
            {/*    {mode === 'view' && <Typography>{viewDetails?.parent?.title}</Typography>}*/}
            {/*    {!props.new && viewDetails?.parent?.id && (*/}
            {/*      <Tooltip title={'View Parent Objective'}>*/}
            {/*        <LinkOutlined*/}
            {/*          onClick={() => {*/}
            {/*            history1.push(*/}
            {/*              `/webux/parent-goal/${props?.performanceCycle?.id}/${viewDetails?.parent.id}/${viewDetails?.parent?.title}/view`,*/}
            {/*            );*/}
            {/*          }}*/}
            {/*        />*/}
            {/*      </Tooltip>*/}
            {/*    )}*/}
            {/*  </Space>*/}
            {/*</Row>*/}
          </div>
        </Form>
        {!props.new && id && (
          <div>
            <UpdatesCard type="objective" id={id} disable={props.disable ?? false} />
          </div>
        )}
        <Divider />
        {mode === 'edit' && (
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
              {props.new && (
                <Button
                  type="default"
                  onClick={() => {
                    props.new ? createGoal() : saveDetails();
                  }}
                  icon={<SnippetsOutlined />}>
                  Save
                </Button>
              )}
            </div>
          </div>
        )}
      </Spin>
      <Modal
        open={keyResultOpen}
        maskClosable={false}
        onCancel={() => {
          if (((keyResultId.current ?? '') + '')?.slice(0, 3) === 'new') {
            const answer = window.confirm(
              'Data will be lost if you close the modal, are you sure??',
            );
            if (answer) {
              setKeyResultOpen(false);
              keyResultId.current = undefined;
              setKeyObject(undefined);
              setDetails();
              events.emit('VALUE_CHANGE_RELOAD');
            }
          } else {
            setKeyResultOpen(false);
            keyResultId.current = undefined;
            setKeyObject(undefined);
            setDetails();
            events.emit('VALUE_CHANGE_RELOAD');
          }
        }}
        footer={null}
        destroyOnClose={true}>
        {keyResultId.current && (
          <KeyResult
            keyResultCount={viewDetails?.keyResults.length}
            id={keyResultId.current}
            mode={mode}
            keyObject={keyObject}
            disable={props.disable ?? false}
            setClose={() => {
              setKeyResultOpen(false);
              keyResultId.current = undefined;
              setDetails();
              events.emit('VALUE_CHANGE_RELOAD');
            }}
            objectiveId={props.new ? 'new' : id}
            onDelete={(id) => {
              setViewDetails((prev: any) => {
                const filteredArray: any[] = (prev?.keyResults ?? []).filter(
                  (x: any) => +x.id !== +id,
                );
                return recalculateObjective({ ...prev, keyResults: filteredArray });
              });
              setKeyResultOpen(false);
              setKeyObject(undefined);
              keyResultId.current = undefined;
            }}
            onSave={(value) => {
              setViewDetails((prev: any) => {
                const keyResults = prev?.keyResults ?? [];
                const index = keyResults.findIndex((item: any) => item.id === value.id);
                const existingKeyResult = index === -1 ? undefined : keyResults[index];
                const nextKeyResult = {
                  ...existingKeyResult,
                  ...value,
                  weight: value?.weight ?? existingKeyResult?.weight ?? 1,
                };
                const nextKeyResults =
                  index === -1
                    ? [...keyResults, nextKeyResult]
                    : keyResults.map((item: any, i: number) =>
                        i === index ? nextKeyResult : item,
                      );
                return recalculateObjective({ ...prev, keyResults: nextKeyResults });
              });
              // if (close) {
              //   setKeyObject(undefined);
              //   setKeyResultOpen(false);
              //   keyResultId.current = undefined;
              // }
            }}
          />
        )}
      </Modal>
    </div>
  );
};

export default Objective;
